import API from "../Services/API"
import Model from "./Model"

const useUnreadThreads = () => {
    return Model({
        alwaysRefresh: true,
        returnDataKey: 'unread',
        stateKey: ['threads', 'unread'],
        fetchData: async () => API.get('/messages/threads/unread'),
        defaultLoadingError: 'Sorry, there was an error loading your messages.',
    });
}

const useRecentThreads = (limit = 20) => {
    return Model({
        alwaysRefresh: true,
        returnDataKey: 'recent',
        stateKey: ['threads', 'recent', limit],
        fetchData: async () => API.get(`/messages/threads/recent?limit=${limit}`),
        defaultLoadingError: 'Sorry, there was an error loading your messages.',
    });
}

export {
    useUnreadThreads,
    useRecentThreads,
};
